<div>
    <div class="container">
        <div class="header">
            <div class="datanyze-logo" (click)="goToHomepage()">
                <img class="datanyze-logo-icon"  alt="" [src]="img">
            </div>
        </div>

        <div class="body">
            <div class="text">
                <p>
                    <span>Datanyze</span> is Better on <br>
                    Desktop Chrome Browser
                </p>
            </div>
            <div class="gifContainer">
                <img alt="" [src]="mobileGif">
            </div>


            <div class="text">
                <p>
                    Soon we will be more <br> mobile friendly...
                </p>
            </div>


            <div class="link-cta">
                <span (click)="goToHomepage()">Back to Homepage</span>
            </div>


        </div>



    </div>


</div>
